<template>
  <div class="golfoffice">
    <div class="golfoffice--content">
      <p>{{ $t('Businessboard.deleteCategoryConfirm', {id: id}) }}</p>
          <div class="input-group--inline user__actions">
              <base-button
              :text="$t('no')"
              @click="back">
              </base-button>
              <base-button
                :text="$t('yes')"
                @click="deleteCategory"
                v-element-loader="{ loaderKey: 'delete-group' }"/>
          </div>
        </div>
    </div>
</template>

<script>
import BaseButton from '@/components/form-elements/base-button';
import elementLoader from '@/directives/element-loader';

export default {
  name: 'DeleteGroup',
  components: {
    BaseButton,
  },
  directives: {
    elementLoader,
  },
  props: {
    id: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
    };
  },
  methods: {
    back () {
      window.history.back();
    },
    deleteCategory() {
      this.$store.dispatch('businessboard/deleteMembershipCategory', { id: this.id, loader: 'delete-category' })
        .then(() => { this.back(); });
    },
  },
};

</script>
<style lang="scss" scoped>
  .golfoffice {
    // margin: 1rem;
    flex-grow: 1;
    width: 100%;
    @include media('small') {
      width: calc((100% / 2) - (1rem * 1));
    }
    @include media('large') {
      width: calc((100% / 3) - (1rem * 2));
    }
  }
  .golfoffice--content {
    background-color: color(white);
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
    padding: 1rem 1.5rem;

    button {
      margin-left: 1.25rem;
    }
  }
</style>
